import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/layout/Navbar";
import { Toaster } from "./components/ui/sonner";
import Dashboard from "./pages/Dashboard";
import GameDetail from "./pages/GameDetail";
import Settings from "./pages/Settings";
import DataStatus from "./pages/DataStatus";
import FeatureCoverage from "./pages/FeatureCoverage";
import SubscriberAdmin from "./pages/SubscriberAdmin";
import HistoricalGames from "./pages/HistoricalGames";
import BestBets from "./pages/BestBets";
import LineMovement from "./pages/LineMovement";
import KalshiBigMoney from "./pages/KalshiBigMoney";
import HowToUse from "./pages/HowToUse";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Subscribe from "./pages/Subscribe";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Welcome from "./pages/Welcome";
import { AdminGate } from "./components/shared/AdminGate";
import { RequireAuth, RequireSubscription } from "./components/shared/ProtectedRoute";
import { BbLinkHandler } from "./components/shared/BbLinkHandler";

function App() {
  return (
    <div className="App min-h-screen bg-eb-bg font-body text-white">
      <BrowserRouter>
        <Navbar />
        <BbLinkHandler />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route
            path="/admin"
            element={
              <AdminGate>
                <DataStatus />
              </AdminGate>
            }
          />
          <Route
            path="/feature-coverage"
            element={
              <AdminGate>
                <FeatureCoverage />
              </AdminGate>
            }
          />
          <Route
            path="/admin/subscribers"
            element={
              <AdminGate>
                <SubscriberAdmin />
              </AdminGate>
            }
          />

          <Route element={<RequireAuth />}>
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/welcome" element={<Welcome />} />
          </Route>

          <Route element={<RequireSubscription />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/games/:gameId" element={<GameDetail />} />
            <Route path="/explorer" element={<HistoricalGames />} />
            <Route path="/best-bets" element={<BestBets />} />
            <Route path="/kalshi-big-money" element={<KalshiBigMoney />} />
            <Route path="/line-movement" element={<LineMovement />} />
            <Route path="/how-to-use" element={<HowToUse />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
